var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"white--text font-weight-light",staticStyle:{"line-height":"1rem","font-size":".75rem"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }